import { useQuery } from "@tanstack/react-query";
import { VehicleRequestService } from "../../../../../services/company-office/VehicleRequestService";
import { requestStatus } from "../../../../../constants";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useSelector } from "../../../../../store/store";

export const useVehicleRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["vehicle-requests"],
    queryFn: () =>
      VehicleRequestService.getVehicleRequests(userEmail, requestStatus.submitted),
  });

  const vehicleMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const mappedVehicleRequests = data.map((record) => {
    const status = getStatusBaseOnApprover(record.fields, userEmail);
    const step = getStepBaseOnApprover(record.fields, userEmail);

    return {
      ...record.fields,
      id: record.id,
      createdByEmail: record.createdBy.user.email,
      createdByName: record.createdBy.user.displayName,
      createdDateTime: record.createdDateTime,
      eRequestStatus: transformRequestStatus(status, { step }),
    };
  }).sort((a,b) => b.id - a.id);

  const mappedVehicleMyRequests = mappedVehicleRequests.filter(
    (record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase()
  ).sort((a,b) => b.id - a.id);

  const guideLink = "https://drive.google.com/file/d/1At7SmP1xu0E2ydUFdQSCkPC6OlJYVv9n/view?usp=drive_link";

  return {
    ...restResponse,
    vehicleRequests: data,
    vehicleMyRequests,
    mappedVehicleRequests,
    mappedVehicleMyRequests,
    guideLink
  };
};
